import axios from 'axios'
import store from '../../store'
  
export const mixin = {
    data: function(){
      return {
        pooling: '',
        loginUrl: process.env.VUE_APP_LOGIN_URL,
        docUrl: process.env.VUE_APP_DOC_URL,
        faqUrl: process.env.VUE_APP_FAQ_URL,
        devDocUrl: process.env.VUE_APP_DEV_DOC_URL,
        confForBlogUrl: process.env.VUE_APP_CONF_FOR_BLOG_URL,
        siteBaseUrl: process.env.VUE_APP_SITE_BASE_URL
      }
    },

    computed: {
      loggedIn() {
        return store.state.authToken.length
      }
    },

    methods: {
      notify(message, autoFade = true, type = 'notice', timeout = 3000) {
  
        const vc = this;
        $('#notify').removeClass(['error','notice']).addClass(type)
        $('#notify .info').html(message)
        vc.toggleDiv('#notify');

        $('#notificationsBar ul').append('<li class="' + type + '">' + message + '</li>')
  
        if(autoFade) {
          setTimeout(function(){
            $('#notify').fadeOut().removeClass('show');
          }, timeout)
        }
  
      },
      
      toggleDiv(id, autoFade = false, toggleFade = true) {
        $(id).toggleClass('show');

        if(toggleFade)
          $(id).fadeToggle()

        if(autoFade) {
          setTimeout(function(){
            $(id).toggleClass('show');

            if(toggleFade)
              $(id).fadeToggle()
          }, 2000)
        }
      },

      popUp(heading, content) {
        $('#infoBox .header').html(heading)
        $('#infoBox .info').html(content)
        $('#infoBox').addClass('show').fadeIn()
      },

      fetchConfigs: function( pooling = false ) {

        const vc = this

        axios
        .get(process.env.VUE_APP_API_URL+'/configs', {
          headers: {
            'Authorization': 'Bearer '+store.state.authToken
          }
        })
        .then( function(response){
          store.commit('setConfigs', response.data.configs);
          
          if(pooling) {
            vc.fetchConfigs()

            vc.pooling = setInterval( function(){
              vc.fetchConfigs();
              vc.refreshAuth();
            }.bind(vc), 60000);
          }

        }).catch(function(err) {
          console.log(err);
        });
  
      },

      refreshAuth: function() {

        // Check if session is about to expire
        var a = this.$moment()
        var b = this.$moment(this.getCookie('refreshTokenExpire'))
        
        //console.log(b.diff(a, 'minutes'))

        if(b.diff(a, 'minutes') < 10) {
          axios
          .post(process.env.VUE_APP_AUTH_URL+'/refresh', { "refresh_token": store.state.refreshToken }, {
              headers: {
                  'Authorization': 'Bearer '+store.state.authToken,
              }
            }
          )
          .then( function(response){
            console.log('Updating Auth Token')
            store.commit('setAuthToken', response.data.access_token)
            store.commit('setRefreshToken', store.state.refreshToken)
          }).catch(function(err) {
            console.log(err);
          });
        }
  
      },

      getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      },

      createEmptyConfig(configId) {
        const vc = this;
        
        axios
        .put(process.env.VUE_APP_API_URL+'/configs/'+configId+'/postgresql.conf', {
            headers: {
                'Authorization': 'Bearer '+store.state.authToken,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
          }
        )
        .then( function(response){
          axios
          .get(process.env.VUE_APP_API_URL+'/configs', {
            headers: {
              'Authorization': 'Bearer '+store.state.authToken
            }
          })
          .then( function(response){
            //var configs = response.data.configs;
            store.commit('setConfigs', response.data.configs);
            vc.$router.push('/manage/config/'+configId)
          })
          .catch(function(err) {
            vc.notify('<p>There was an error trying to create your configuration.</p>', false, 'error')
            //vm.requestAuth();
            console.log(err);
          });
        })
        .then(function(){
          vc.notify('<p>Configuration created successfuly.</p>', true)
        })
        .catch(function(err) {
          vc.notify('<p>There was an error trying to upload your file.</p>', false, 'error')
          console.log(err);
        });
      },

      getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(var i = 0; i < ca.length; i++) {
          var c = ca[i];
          while (c.charAt(0) == ' ') {
            c = c.substring(1);
          }
          if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
          }
        }
        return "";
      }
    },
}